var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3182 0.0667064C15.2087 -0.00708064 15.0693 -0.0204964 14.9471 0.0309309L10.3625 1.94119L5.77712 0.0301856C5.68023 -0.0100619 5.57066 -0.0100619 5.47302 0.0301856L0.736377 2.0038C0.589544 2.06566 0.494141 2.20876 0.494141 2.36826V14.605C0.494141 14.7369 0.559731 14.8599 0.670041 14.9337C0.735631 14.9776 0.812401 15 0.889172 15C0.9406 15 0.992029 14.9903 1.04122 14.9694L5.62582 13.0592L10.2104 14.9694C10.3073 15.0097 10.4169 15.0097 10.5145 14.9694L15.2512 12.9958C15.398 12.9347 15.4941 12.7909 15.4941 12.6314V0.394649C15.4941 0.262726 15.4278 0.139748 15.3182 0.0667064ZM6.0201 0.987181L9.96743 2.63211V14.0132L6.0201 12.3683V0.987181ZM1.28346 2.63136L5.23079 0.986435V12.3675L1.28346 14.0124V2.63136ZM14.7041 12.3683L10.7567 14.0132V2.63136L14.7041 0.986435V12.3683Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapview);
export default __webpack_public_path__ + "static/media/mapview.d4ebc4b769ffb6121099223b15ca75e4.svg";
export { ForwardRef as ReactComponent };